import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { DesiccantAirDryerNodeModel } from './DesiccantAirDryerNodeModel';
import { DesiccantAirDryerNodeWidget } from './DesiccantAirDryerNodeWidget';

export class DesiccantAirDryerNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.DesiccantAirDryer);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new DesiccantAirDryerNodeModel();
  }

  nodeUI(event) {
    return <DesiccantAirDryerNodeWidget engine={this.engine} node={event.model} width={142} height={174} />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
